/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_Backend_Prod_ContinueInputs */

const en_mobile_dev_backend_prod_continue = /** @type {(inputs: Mobile_Dev_Backend_Prod_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch anyway`)
};

const es_mobile_dev_backend_prod_continue = /** @type {(inputs: Mobile_Dev_Backend_Prod_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar de todos modos`)
};

/**
* | output |
* | --- |
* | "Switch anyway" |
*
* @param {Mobile_Dev_Backend_Prod_ContinueInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_backend_prod_continue = /** @type {((inputs?: Mobile_Dev_Backend_Prod_ContinueInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_Backend_Prod_ContinueInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_backend_prod_continue(inputs)
	return en_mobile_dev_backend_prod_continue(inputs)
});